/* eslint-disable react/prop-types */
import React from 'react';
import cn from 'clsx';
import { Form } from 'antd';
import classes from './FormItem.module.scss';

const FormItem = ({ children, className, half, noMargin, label, required, ...other }) => {
  return (
    <Form.Item
      {...other}
      label={
        !!label ? (
          <>
            {label}
            {required && <span style={{ color: 'red', marginLeft: '4px' }}>*</span>}
          </>
        ) : null
      }
      className={cn(
        classes.wrapper,
        {
          [classes.half]: half,
          [classes.noMargin]: noMargin,
        },
        className
      )}>
      {children}
    </Form.Item>
  );
};

export default FormItem;
